import { Component } from "react";
import { lockScroll, unlockScroll } from "../../Util/Util/scroll-lock.js";
/* empty css                    */
class LockBodyScroll extends Component {
  componentDidMount() {
    lockScroll();
  }
  componentWillUnmount() {
    unlockScroll();
  }
  render() {
    return null;
  }
}
export {
  LockBodyScroll as default
};
//# sourceMappingURL=LockBodyScroll.js.map
